import { useProcedureDeleteMutation } from "../../../../../api/procedure/useProcedureDeleteMutation";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";

export function useDelete({ onSuccess }) {
  const { tCommon } = useAppTranslation.Common();

  const deleteMutation = useProcedureDeleteMutation({
    onSuccess,
    onError: (e) => {
      const message = extractApiError(e);
      uiNotification.error(
        tCommon([`apiError.qualiphy.${message}`, "error.deleteProcedure"]),
      );
    },
  });

  const deleteProcedure = ({ procedureId }) => {
    if (window.confirm(tCommon("confirm.deleteProcedure"))) {
      deleteMutation.mutate({
        procedureId,
      });
    }
  };

  return {
    deleteProcedure,
    isDeleting: deleteMutation.isLoading,
  };
}
